<template>
    <div class="result-main-box">
        <a-spin :spinning="spinning" size="large" :tip="spinTip">
        <bkNav :showSearch="true" :isParentSearch="true" 
            @simpleSearch="simpleSearch" @advancedsearch="advancedsearch"
            @bkSearchShow="bkSearchShow" @bkSearchHide="bkSearchHide"
        />
        <div :class="bkSearchTabShow ? 'result-main cur' : 'result-main'">
            <div class="top-ctrl">
                <!-- <span @click="onExport"><img src="./img/icon4.png" alt=""> 结果导出</span> -->
                <span @click="charts"><img src="./img/icon5.png" alt=""> 结果可视化</span>
                <!-- <span><img src="./img/icon6.png" alt=""> GIS分析</span> -->
            </div>
            <div class="result-container">
                <div :class="animateFlag?'middle-result cur':'middle-result'">
                    <div class="result-from">
                        <div class="from-cell">
                            <div class="arr">
                                <span></span>
                                <a-icon @click="()=>{this.showMore0=!this.showMore0}" :type="showMore0?'up':'down'" class="arrow"></a-icon>
                            </div>
                            <div class="ct-nox">
                                <div class="ts">文献类型</div>
                                <ul :style="{height:22*(showMore0?wxTypetList.length:3)+'px'}" :class="{'cur': this.showMore0}">
                                    <li v-for="(lt,index) in wxTypetList" :key="index" :class="(showMore0?true:(index<3))?'cur':''">
                                        <a href="javascript:;" @click="onFacetClick(lt, 'ST')">{{lt.facet}}</a>
                                        <span>{{lt.count}}</span>
                                    </li>
                                </ul>
                                <div class="more" v-if="wxTypetList && wxTypetList.length > 3">
                                    <span @click="()=>{this.showMore0=!this.showMore0}">{{showMore0?'收起搜索结果':'展开搜索结果'}}</span>
                                    <!-- <a href="" class="all"><img src="./img/icon3.png" alt=""> 查看全部</a> -->
                                </div>
                            </div>
                        </div>
                        <div class="from-cell">
                            <div class="arr">
                                <span></span>
                                <a-icon @click="()=>{this.showMore1=!this.showMore1}" :type="showMore1?'up':'down'" class="arrow"></a-icon>
                            </div>
                            <div class="ct-nox">
                                <div class="ts">内容类型</div>
                                <!--  :style="{height:22*(showMore1?nrTypeTreeNodes.length:3)+'px'}" -->
                                <ul class="ztree" id="nrTypeTreeId" :class="{'cur': this.showMore1}">
                                    <!-- <li v-for="(lt,index) in nrTypeList" :key="index" :class="(showMore1?true:(index<3))?'cur':''">
                                        <a href="">{{lt.facet}}</a>
                                        <span>{{lt.count}}</span>
                                    </li> -->
                                    <!-- <li class="ztree cur" id="nrTypeTreeId">123456</li> -->
                                </ul>
                                <div class="more" v-if="nrTypeTreeNodes && nrTypeTreeNodes.length > 3">
                                    <span @click="()=>{this.showMore1=!this.showMore1}">{{showMore1?'收起搜索结果':'展开搜索结果'}}</span>
                                    <!-- <a href="" class="all"><img src="./img/icon3.png" alt=""> 查看全部</a> -->
                                </div>
                            </div>
                        </div>
                        <div class="from-cell">
                            <div class="arr">
                                <span></span>
                                <a-icon @click="()=>{this.showMore2=!this.showMore2}" :type="showMore2?'up':'down'" class="arrow"></a-icon>
                            </div>
                            <div class="ct-nox">
                                <div class="ts">文献来源</div>
                                <ul :style="{height:22*(showMore2?wxSourceList.length:3)+'px'}" :class="this.showMore2?'cur': 'cur2'">
                                    <li v-for="(lt,index) in (showMore2?wxSourceList:wxSourceList.slice(0, 3))" :key="index" :class="(showMore2?true:(index<3))?'cur':''">
                                        <a href="javascript:;" @click="onFacetClick(lt, 'SR')">{{lt.facet}}</a>
                                        <span>{{lt.count}}</span>
                                    </li>
                                </ul>
                                <div class="more" v-if="wxSourceList && wxSourceList.length > 3">
                                    <span @click="()=>{this.showMore2=!this.showMore2}">{{showMore2?'收起搜索结果':'展开搜索结果'}}</span>
                                    <!-- <a href="" class="all"><img src="./img/icon3.png" alt=""> 查看全部</a> -->
                                </div>
                            </div>
                        </div>
                        <div class="from-cell">
                            <div class="arr">
                                <span></span>
                                <a-icon @click="()=>{this.showMore3=!this.showMore3}" :type="showMore3?'up':'down'" class="arrow"></a-icon>
                            </div>
                            <div class="ct-nox">
                                <div class="ts">责任者</div>
                                <ul :style="{height:22*(showMore3?wxzrzList.length:3)+'px'}" :class="this.showMore3? 'cur': 'cur2'">
                                    <li v-for="(lt,index) in (showMore3?wxzrzList:wxzrzList.slice(0, 3))" :key="index" :class="(showMore3?true:(index<3))?'cur':''">
                                        <a href="javascript:;" @click="onFacetClick(lt, 'CO')">{{lt.facet}}</a>
                                        <span>{{lt.count}}</span>
                                    </li>
                                </ul>
                                <div class="more" v-if="wxzrzList && wxzrzList.length > 3">
                                    <span @click="()=>{this.showMore3=!this.showMore3}">{{showMore3?'收起搜索结果':'展开搜索结果'}}</span>
                                    <!-- <a href="" class="all"><img src="./img/icon3.png" alt=""> 查看全部</a> -->
                                </div>
                            </div>
                        </div>
                        <div class="from-cell">
                            <div class="arr">
                                <span></span>
                                <a-icon @click="()=>{this.showMore4=!this.showMore4}" :type="showMore4?'up':'down'" class="arrow"></a-icon>
                            </div>
                            <div class="ct-nox">
                                <div class="ts">出版时间</div>
                                <ul :style="{height:22*(showMore4?publishingTimeList.length:3)+'px'}" :class="this.showMore4 ? 'cur': 'cur2'">
                                    <li v-for="(lt,index) in (showMore4?publishingTimeList:publishingTimeList.slice(0, 3))" :key="index" :class="(showMore4?true:(index<3))?'cur':''">
                                        <a href="javascript:;" @click="onFacetClick(lt, 'SJ')">{{lt.facet}}</a>
                                        <span>{{lt.count}}</span>
                                    </li>
                                </ul>
                                <div class="more" v-if="publishingTimeList && publishingTimeList.length > 3">
                                    <span @click="()=>{this.showMore4=!this.showMore4}">{{showMore4?'收起搜索结果':'展开搜索结果'}}</span>
                                    <!-- <a href="" class="all"><img src="./img/icon3.png" alt=""> 查看全部</a> -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div :class="animateFlag?'right-act cur':'right-act'">
                    <div class="search-info">
                        <div class="pages">
                            <a href="javascript:" class="first" @click="firstPage"></a>
                            <a href="javascript:" class="prev"  @click="prevPage"></a>
                            <select v-model="pageth" @change="onPagethChange">
                                <!-- <option>1/3</option>
                                <option>2/3</option>
                                <option>3/3</option> -->
                                <option v-for="p in pageCount" :key="'p'+p" :value="p">{{p}}/{{pageCount}}</option>
                            </select>
                            <!-- <a-select v-model="pageth" @change="onPagethChange">
                                <a-select-option v-for="p in pageCount" :key="'p'+p" :value="p"
                                >{{p}}/{{pageCount}}</a-select-option>
                            </a-select> -->
                            <a href="javascript:" class="next" @click="nextPage"></a>
                            <a href="javascript:" class="last" @click="lastPage"></a>
                            <select class="lg" v-model="pageSize" @change="onPageSizeChange">
                                <option value="10">每页10条</option>
                                <option value="20">每页20条</option>
                            </select>
                        </div>
                        <!-- <div class="info">找到 29194 个结果 | 用时 0.12 秒</div> -->
                        <div class="sort">
                            <!-- <span class="star"></span> -->
                            <select v-model="bkSort" @change="onSortChange">
                                <option value="0">降序</option>
                                <option value="1">顺序</option>
                            </select>
                            <select class="lg" v-model="LG" @change="onSortChange">
                                <option value="TI">题名</option>
                                <option value="CO">作者</option>
                                <option value="SJ">时间</option>
                            </select>
                        </div>
                    </div>
                    <div class="result-info">
                        <!-- <span v-if="Common.userInfo">
                            <a-checkbox 
                                :checked="checkboxAll"
                                :indeterminate="indeterminate"
                                @change="onCheckAllChange"
                            ></a-checkbox>
                        </span> -->
                        <div class="info">找到 {{rowCount}} 个结果<span class="vertical"> | </span>用时 {{totalTime}} 秒</div>
                    </div>
                    <div class="r-list">
                        <!-- <a-checkbox-group v-model="checkedList" @change="onChange"> -->
                            <div class="r-cell" v-for="(item,index) in dataSource" :key="index">
                                <!-- <span :class="item.isSelect?'check cur':'check'" @click="handleSelect(index)"></span> -->
                                <!-- <span class="checkbox" v-if="Common.userInfo">
                                    <a-checkbox></a-checkbox>
                                </span> -->
                                <div class="info">
                                    <!-- <a-checkbox :value="item" 
                                        v-if="Common.userInfo && (item.hasOwnProperty('title') || item.hasOwnProperty('work'))"
                                    ></a-checkbox> -->
                                    <span v-if="item.hasOwnProperty('title') || item.hasOwnProperty('work')"
                                        @mouseenter="handleHoverB($event, item)" @mouseleave="handleLeaveB"
                                    >
                                    {{item.title || item.work.title}}
                                    </span>
                                    <div class="des">
                                        <!--  @mouseenter="handleHoverP($event)" -->
                                        <!-- <a-checkbox :value="item" 
                                            v-if="Common.userInfo && (item.co || item.source) && !(item.hasOwnProperty('title') || item.hasOwnProperty('work'))"
                                        ></a-checkbox> -->
                                        <span v-if="item.co">
                                            <a :href="co.uri&&co.uri.indexOf('bk')==-1?co.uri:'javascript:;'" 
                                               :target="co.uri&&co.uri.indexOf('bk')==-1?'_blank':''"
                                                v-for="(co, index) in item.co" :key="'co'+index"
                                            >{{co.agent}}&nbsp;</a>
                                        </span>
                                        <!-- <span>{{"《"+item.newspaper.titleChs+"》"}}</span> -->
                                        <span v-if="item.source">{{item.source}}</span>
                                    </div>
                                </div>
                                <div class="btns">
                                    <a href="javascript:;" @click="fullBrowse(item)" 
                                        v-if="item['@id'].indexOf('/advertisement/') == -1 
                                        && (item.titlePy.indexOf('ti xiao yin yuan')!=-1 && item.source.indexOf('《新闻报》')!=-1 
                                            || item.source.indexOf('《语丝》')!=-1)"
                                    >
                                        <img src="./img/yulan.png" alt="" title="整本浏览">
                                    </a>
                                    <a v-if="item.newspaper && item.newspaper.typeName 
                                        && (item.titlePy.indexOf('ti xiao yin yuan')!=-1 && item.source.indexOf('《新闻报》')!=-1 
                                            || item.source.indexOf('《语丝》')!=-1)" 
                                        href="javascript:;" @click="yulan2(item)">
                                        <img src="./img/yulan2.png" alt="" title="单篇预览">
                                    </a>
                                    <a href="javascript:;" v-if="item.work 
                                        && (item.titlePy.indexOf('ti xiao yin yuan')!=-1 && item.source.indexOf('《新闻报》')!=-1 
                                            || item.source.indexOf('《语丝》')!=-1)" 
                                        @click="zjBrowse(item)">
                                        <img src="./img/zhuanji.png" alt="" title="专辑浏览">
                                    </a>
                                    <a href="javascript:;" v-if="Common.userInfo">
                                        <span title="收藏" :class="collectedDataSource.indexOf(item['@id'])>-1?'star cur':'star'" 
                                            @click="handleFav(item['@id'], item.title||'', item.newspaper['@type'], item.issue && item.issue.publishedIn?item.issue.publishedIn[0].year:'', item.issue && item.issue.issueNo ? item.issue.issueNo:'')"
                                        ></span>
                                        <!-- <span title="收藏" :class="item.isFav?'star cur':'star'" @click="handleFav(index)"></span> -->
                                        <!-- theme = 'filled' | 'outlined' | 'twoTone' -->
                                        <!-- <a-icon type="star" theme=""></a-icon> -->
                                    </a>
                                    <!-- <router-link to="/"><img src="./img/xiazai.png" alt="">下载</router-link> -->
                                </div>
                            </div>
                        <!-- </a-checkbox-group> -->
                    </div>
                </div>
                <div class="left-box">
                    <div :class="animateFlag?'info-box cur':'info-box'">
                        <div class="taps">
                            <!-- <span :class="infoTap===0?'cur':''" @click="changeInfoTap(0)" v-html="highLight('李鸿章')"></span>
                            <span :class="infoTap===1?'cur':''" @click="changeInfoTap(1)" v-html="highLight('李鸿章')">王鸿章</span>
                            <span :class="infoTap===2?'cur':''" @click="changeInfoTap(2)" v-html="highLight('李鸿章')">张鸿章</span> -->
                            <span v-for="(item, index) in personList" :key="'person'+index"
                                :class="infoTap===index?'cur':''" @click="changeInfoTap(item, index)" 
                                v-html="highLight(item)"
                            ></span>
                        </div>
                        <div class="detail">
                            <!-- <i class="icon"></i> -->
                            <img v-if="personInfo && personInfo.img" :src="personInfo.img+'!500x500'" alt="">
                            <div class="txt" v-if="personInfo">
                                <p v-if="personInfo.briefBiography">{{personInfo.briefBiography.slice(0, 40)+'......'}}</p>
                                <table>
                                    <tr v-if="personInfo.name">
                                        <td>姓名</td><td>{{personInfo.name}}</td>
                                    </tr>

                                    <tr v-if="personInfo.birthday && personInfo.deathday">
                                        <td>生卒</td><td>{{personInfo.birthday+'-'+personInfo.deathday}}</td>
                                    </tr>
                                    <tr v-else-if="personInfo.birthday">
                                        <td>生卒</td><td>{{personInfo.birthday+'-'}}</td>
                                    </tr>
                                    <tr v-else-if="personInfo.deathday">
                                        <td>生卒</td><td>{{'-'+personInfo.deathday}}</td>
                                    </tr>

                                    <tr v-if="personInfo.place">
                                        <td>籍贯</td><td>{{personInfo.place}}</td>
                                    </tr>
                                    <tr v-if="personInfo.gender">
                                        <td>性别</td><td>{{personInfo.gender}}</td>
                                    </tr>
                                    <tr v-if="personInfo.ethnicity">
                                        <td>民族</td><td>{{personInfo.ethnicity}}</td>
                                    </tr>
                                    <tr v-if="personInfo.dynasty">
                                        <td>朝代</td><td>{{personInfo.dynasty}}</td>
                                    </tr>
                                    <tr v-if="!isEmpty(namesHandle('字', '号', personInfo.yName))">
                                        <td>字号</td><td>{{namesHandle('字', '号', personInfo.yName)}}</td>
                                    </tr>
                                    <!-- <tr v-if="!isEmpty(namesHandle('谥号', '諡號', personInfo.yName))">
                                        <td>谥号</td><td>{{namesHandle('谥号', '諡號', personInfo.yName)}}</td>
                                    </tr> -->
                                    <tr>
                                        <td colspan="2">...</td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                        <div class="bottom">
                            <!-- <span class="more">
                                 <a-icon style="font-size: 20px" type="ellipsis" />
                            </span> -->
                            <a href="//names.library.sh.cn/mrgf/service/person/list" target="_blank" v-if="!keyword">
                                <span class="more">
                                    <a-icon style="font-size: 20px;" type="ellipsis"/>
                                </span>
                            </a>
                            <a :href="'//names.library.sh.cn/mrgf/service/person/list?freetext='+keyword" target="_blank" v-else>
                                <span class="more">
                                    <a-icon style="font-size: 20px;" type="ellipsis"/>
                                </span>
                            </a>
                            <div class="ot">
                                <!-- <router-link to="/"> -->
                                <a v-if="personInfo && personInfo.uri" :href="personInfo.uri" target="_blank">
                                    <img src="./img/icon1.png" alt="">
                                    人物详情
                                </a>
                                <!-- </router-link> -->
                                <!-- :href="'https://dhc.library.sh.cn/uc/relation.html?uri='+personInfo.uri" target="_blank" -->
                                <a v-if="personInfo && personInfo.uri" href="javascript:;"
                                    @click="onRelation(personInfo.uri, null)"
                                >
                                    <img src="./img/icon2.png" alt="">
                                    关系图谱
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="person-hover" v-if="showHoverPerson" :style="{'top':hoverPersonY+'px','left':hoverPersonX+'px'}">
            <img src="/demo.jpg" alt="">
            <div class="info">
                <div class="name">恨水</div>
                <div class="des">孙伏园（1894年－1966年1月2日），原名福源，字养泉，笔名伏庐、柏生、桐柏、松年等。绍兴人。现代散文作家、著名副刊编辑，在新闻学上有民国“副刊大王”之称。</div>
                <div class="ot">
                    <router-link to="/">
                        <img src="./img/icon1c.png" alt="">
                        人物详情
                    </router-link>
                    <router-link to="/">
                        <img src="./img/icon2c.png" alt="">
                        关系图谱
                    </router-link>
                </div>
            </div>
            <a-icon type="close" style="position: absolute;top: 8px;right: 8px" @click="handleLeaveP"></a-icon>
        </div>

        <div class="book-hover" v-if="showHoverBook" :style="{'top':hoverBookY+'px','left':hoverBookX+'px'}">
            <div class="desc">
                <div class="lf">
                    <p  v-if="handleHoverItem.title || handleHoverItem.work.title"
                    >题名：{{handleHoverItem.title || handleHoverItem.work.title}}</p>
                    <p v-if="handleHoverItem.co && arrayToString(handleHoverItem.co, 'agent', ' ')"
                    >作者：<span>{{arrayToString(handleHoverItem.co, 'agent', ' ')}}</span></p>
                    <p v-if="handleHoverItem.source"
                    >文献来源：{{handleHoverItem.source}}</p>
                </div>
                <div class="rt">
                    <p v-if="(handleHoverItem.sj && handleHoverItem.sj.year) || 
                        ( handleHoverItem.issue && handleHoverItem.issue.publishedIn && 
                          arrayToString(handleHoverItem.issue.publishedIn, 'year', ' ') )"
                    >出版时间：{{handleHoverItem.sj&&handleHoverItem.sj.year?handleHoverItem.sj.year:arrayToString(handleHoverItem.issue.publishedIn, 'year', ' ')}}</p>
                    <p v-if="handleHoverItem.source && splitString(handleHoverItem.source)"
                    >卷期(页)：{{splitString(handleHoverItem.source)}}</p>
                    <p v-if="handleHoverItem.classification && handleHoverItem.classification.code"
                    >中图分类号：{{handleHoverItem.classification.code['@value']}}</p>
                </div>
            </div>
            <div class="des">摘要：<span v-html="handleHoverItem.newspaper.description.slice(0, 69)+'......'"></span></div>
            <!-- <div class="btns">
                <router-link to="/"><img src="./img/yulanc.png" alt="">整本浏览</router-link>
                <router-link to="/bk/magazineimg"><img src="./img/yulan2c.png" alt="">预览</router-link>
                <router-link to="/"><img src="./img/zhuanjic.png" alt="">专辑浏览</router-link>
                <router-link to="/"><img src="./img/xiazaic.png" alt="">下载</router-link>
            </div> -->
            <!-- <a-icon type="close" style="position: absolute;top: 8px;right: 8px" @click="handleLeaveB"></a-icon> -->
        </div>
        </a-spin>

        <a-modal v-model="favorVisible" width="20%" title="请选择收藏夹" @ok="createFav">
            <template slot="footer"><a-button key="cancel" type="default" @click="favorVisible=false;ifCreateFlag=false;inputFolderName=''">取消</a-button></template>
            <template slot="footer"><a-button key="submit" type="primary" @click="createFav" :disabled="ifCreateFlag">收藏</a-button></template>
            <a-radio-group v-show="!ifCreateFlag" v-model="favorFolderId">
                <a-radio v-for="(item, index) in favorFolders" :key="index" :value="item.id">
                    <span>{{item.name}}</span>
                </a-radio>
                <a-icon type="plus" v-if="!ifCreateFlag" @click="ifCreateFlag=true"/>
            </a-radio-group>
            <a-input v-if="ifCreateFlag" v-model="inputFolderName" placeholder="请输入待创建的收藏夹名称" />
            <a-icon  v-if="ifCreateFlag" type="close-circle" @click="ifCreateFlag=false;inputFolderName=''"/>
            <a-icon  v-if="ifCreateFlag" type="check-circle" @click="createFolder(inputFolderName)"/>
        </a-modal>

    </div>
</template>

<script>
    import bkNav from '../nav3/index'
    import 'ztree/js/jquery.ztree.core.js'
    import 'ztree/css/metroStyle/metroStyle.css'
    // import './ztree.less';
    export default {
        components:{
            bkNav,
        },
        data(){
            return{
                inputFolderName: "",
                ifCreateFlag: false,
                favorVisible: false,
                spinning: false, // 加载中...
                spinTip: '',
                infoTap:0,
                arrowChange: 0,
                indeterminate: false,   // 复选框选中状态
                checkboxAll: false,     // 复选框全选
                checkedList: [],        // 复选框组选中数据
                plainOptions: [],       // 复选框组全部数据
                checkboxTotal: false,
                bkSearchTabShow: false,
                isFacet: 0,     // 分面点击
                startTime: 0,   // 开始时间
                totalTime: 0,   // 检索总用时
                bkSort: 0,      // 排序
                LG: 'SJ',       // 排序标题
                searchType: 1,  // 检索类型，1：简单检索，2：高级检索，3：专业检索
                keyword:'',     // 简单检索 例:鸿章
                cdtnParams: [], // 高级检索
                expression: '', // 专业检索
                facetParams:{}, // 分面点击参数
                typesParams:'', // 首页检索文献类型参数
                pageSize: 10,   // 每页显示数目
                pageCount: 1,   // 总页数
                pageth: 1,      // 页码
                rowCount: 0,    // 总数量
                handleHoverItem: {}, // 悬浮弹窗数据
                showMore0:false,
                showMore1:false,
                showMore2:false,
                showMore3:false,
                showMore4:false,
                animateFlag:false,
                personList: [], // 人物信息列表
                personInfo: {}, // 人物信息
                wxTypetList:[], // 文献类型
                nrTypeList:[ // 内容类型
                    {facet:'正文', count:10},
                    {facet:'图片', count:9},
                    {facet:'广告', count:13},
                ],
                wxSourceList:[], // 文献来源
                wxzrzList:[], // 责任者
                publishingTimeList:[], // 出版时间
                showHoverPerson:false,
                hoverPersonX:0,
                hoverPersonY:0,
                showHoverBook:false,
                hoverBookX:0,
                hoverBookY:0,
                dataSource:[
                    // {
                    //     isFav:false, // 是否收藏
                    //     isSelect:false // 是否勾选
                    // }
                ],
                exportList  : [],  // 导出数据
                isNotExport: true, // true：非导出，false：导出
                collectedDataSource: [],
                favUri: "",
                favTitle: "",
                favType: "",
                favYear: "",
                favWeek: "",
                favorFolderId: "",
                favorFolders: [],
                yulanLink: ['/bk/newspaperimg', '/bk/magazineimg'],
                nrTypeTreeObj: null,
                nrTypeTreeNodes: [
                    {
                        "name":"正文", count: 4, children: [
                            { 
                                "name":"正文类别"  , count: 2, children: [
                                    {"name":"消息"  , count: 10, "url":"//dhc.library.sh.cn/bk/home", "target":"_blank"},
                                    {"name":"评论"  , count: 20, "url":"//dhc.library.sh.cn/bk/home", "target":"_blank"}
                                ]
                            },
                            { "name":"文章栏目"  , count: 20 },
                            { 
                                "name":"新闻来源"  , count: 2, children: [
                                    {"name":"中央社"  , count: 10, "url":"//dhc.library.sh.cn/bk/home", "target":"_blank"},
                                    {"name":"路透社"  , count: 20, "url":"//dhc.library.sh.cn/bk/home", "target":"_blank"}
                                ]
                            },
                            { 
                                "name":"新闻发布地", count: 2, children: [
                                    {"name":"上海"  , count: 10, "url":"//dhc.library.sh.cn/bk/home", "target":"_blank"},
                                    {"name":"南京"  , count: 20, "url":"//dhc.library.sh.cn/bk/home", "target":"_blank"}
                                ]
                            }
                        ]
                    },
                    {
                        "name":"图片", count: 2, children: [
                            { "name":"图片栏目", count: 24 },
                            { "name":"图片类型", count: 33 }
                        ]
                    },
                    {
                        "name":"广告", count: 2, children: [
                            { "name":"广告类别", count: 36 },
                            { "name":"广告栏目", count: 66 }
                        ]
                    }
                ],
                setting:{
                    view: {
                        showLine: false,   // 设置 zTree 不显示节点之间的连线
                        nameIsHTML: true, // 设置 name 属性支持 HTML 脚本
                        dblClickExpand: false, //取消默认双击展开父节点的功能
                        showIcon: false,
                        nodeClasses : {add: ['cur']},
                        addDiyDom: this.addDiyDom,
                        fontCss : {
                            color:"#fff", 
                            background: 'transparent',
                        },
                    },
                    data: {
                        key: {
                            name: "facet"
                        },
                        simpleData: {
                            enable: true
                        }
                    },
                    callback: {
                        onClick:  this.zTreeOnClick,    // 分类树点击事件
                        onExpand: this.zTreeOnExpand,    // 分类树展开事件
                        onCollapse: this.zTreeOnCollapse, // 分类树收缩事件
                        onNodeCreated: this.zTreeOnNodeCreated // 节点创建后
                    }
                },
            }
        },
        created() {
        },
        mounted() {
            setTimeout(()=>{
                this.animateFlag = true
            },100)
            
            this.$nextTick(()=>{
                // this.search();
            })
        },
        methods:{
            onFacetClick(data, type){ // 分面点击
                this.isFacet = 1;
                this.pageth = 1;
                this.facetParams = {};
                this.facetParams[type] = data.facet;
                this.getArticleSearch();
            },
            initParams(){ // 初始化参数值
                this.pageth       = 1;
                this.keyword      = ''; // 简单检索参数清空
                this.cdtnParams   = []; // 高级检索参数清空
                this.facetParams  = {}; // 分面检索参数清空
                this.params.sorts = {}; // 排序参数清空
            },
            simpleSearch(obj){ // 简单检索
                this.bkSearchHide(false); // 高级检索框隐藏
                this.initParams(); // 初始化参数值
                this.searchType  = obj.searchType    ? obj.searchType   : 1;
                this.keyword     = obj.simpleKeyword ? obj.simpleKeyword: '';
                let _sourceTypes = obj.sourceTypes   ? obj.sourceTypes  : [];
                let _types       = obj.types         ? obj.types        : [];
                
                this.params.sorts = {};
                this.params.sorts[this.LG] = this.bkSort;
                this.typesParams = "?sourceTypes=" + _sourceTypes.join(',') + "&types=" + _types.join(',');
                this.getArticleSearch();
                this.replaceUrl2('?historyParams='); // 无刷新，改变地址栏
                
                // 检索埋点START
                if(this.activeUserInfo) {
                    this.params.sourceTypes = _sourceTypes;
                    this.params.types       = _types;
                    this.createUserLog("https://dhc.library.sh.cn/bk/searchResult", this.params, "近代报刊库-简单检索")
                }
                // 检索埋点END

                // 检索历史埋点START
                // if(this.activeUserInfo) {
                //     let _history = {
                //         "content": JSON.stringify(this.params)
                //     }
                //     if(this.isEmpty(this.params.freetext)) _history = null;
                //     this.hisRetAndOrdSetting(null, _history, null);
                // }
                // 检索历史埋点END
            },
            advancedsearch(obj){ // 高级检索
                this.bkSearchHide(false); // 高级检索框隐藏
                this.initParams(); // 初始化参数值
                this.searchType  = obj.searchType   ? obj.searchType  : 2;
                this.cdtnParams  = obj.advancedCdtn ? obj.advancedCdtn: [];
                let _sourceTypes = obj.sourceTypes  ? obj.sourceTypes : [];
                let _types       = obj.types        ? obj.types       : [];
                this.typesParams = "?sourceTypes=" + _sourceTypes.join(',') + "&types=" + _types.join(',');
                
                this.params.sorts = {};
                this.params.sorts[this.LG] = this.bkSort;
                this.getArticleSearch();
                this.replaceUrl2('?historyParams='); // 无刷新，改变地址栏

                // 检索埋点START
                if(this.activeUserInfo) {
                    this.params.sourceTypes = _sourceTypes;
                    this.params.types       = _types;
                    this.createUserLog("https://dhc.library.sh.cn/bk/searchResult", this.params, "近代报刊库-高级检索")
                }
                // 检索埋点END

                // 检索历史埋点START
                // if(this.activeUserInfo) {
                //     let _history = {
                //         "content": JSON.stringify(this.params)
                //     }
                //     if(this.isEmpty(this.params.freetext)) _history = null;
                //     this.hisRetAndOrdSetting(null, _history, null);
                // }
                // 检索历史埋点END
            },
            splitString(str){
                let _str = '';
                let index1 = str.indexOf(')');
                let index2 = str.indexOf('年');
                if(index1 != -1){
                    _str = str.split(')')[1]
                }
                else if(index2 != -1){
                    _str = str.split('年')[1]
                }
                return _str;
            },
            async onSortChange(){ // 排序变化
                this.isFacet = 1;
                this.params.sorts = {};
                this.params.sorts[this.LG] = this.bkSort;
                if(this.isNotExport) {
                    this.indeterminate = false;
                    this.checkboxAll   = false;
                }
                await this.getArticleSearch();
            },
            async getArticleSearch(){ // 正文检索
                this.startTime = new Date().getTime();  // 开始时间
                this.spinning  = true; // 加载中...
                // this.typesParams = "?types=Article,Advertisement,Picture&sourceTypes=newspaper,magazine";
                await this.$axios.post(this.bkCommon.articleSearchUrl + this.typesParams, this.params)
                .then((res) => {
                    let resultData = res.data;
                    if(this.isNotExport){
                        this.dataSource   = resultData.datas;
                        let facets        = resultData.facets;
                        // this.plainOptions = this.arrayToString(resultData.datas, '@id', '##').split('##');
                        this.plainOptions = resultData.datas;
                        if(this.isFacet == 0){ // 分面数据
                            this.wxTypetList  = facets.sourceTypeFacet;
                            this.wxSourceList = facets.sourceFacet;
                            this.wxzrzList    = facets.coFacet;
                            this.publishingTimeList = facets.sjFacet;
                            this.zTreeInit('nrType', facets.typeFacet); // 内容类型分面树，数据绑定
                        }
                        this.pageCount = resultData.pager.pageCount;
                        this.rowCount  = resultData.pager.rowCount;
                        // 获取人物信息
                        this.getPerson(facets.pUriFacet);

                        this.totalTime = (new Date().getTime() - this.startTime)/1000; // 计算检索时间(秒)
                        if(this.isFacet == 1) this.isFacet = 0;
                        // 查询用户收藏列表
                        if(this.Common.userInfo) {
                            this.searchCollectCode()
                        }
                    } 
                    else this.exportList = resultData.datas; // 导出时数据
                    this.isNotExport = true;
                    this.spinning = false; // 加载结束
                })
                .catch((err) => {
                    console.log(err)
                });
            },

            // 查询用户收藏列表
            searchCollectCode() {
                this.collectedDataSource = []
                let resourceCodes = []
                this.dataSource.forEach(element => {
                    resourceCodes.push(element["@id"])
                });
                this.$axios.post(this.Common.searchCollectCode, {
                    appId: "history",
                    userId: this.Common.userInfo.id,
                    version: "1.0",
                    token: this.getTokenFunc(),
                    body: {
                        resourceCodes: resourceCodes
                    }
                })
                .then((res) => {
                    if(res.data.resultCode === "0000") {
                        if(res.data.body&&res.data.body.length>0) {
                            res.data.body.forEach(element => {
                                this.collectedDataSource.push(element.resourceCode)
                            });
                        }
                    } else {
                        this.$message.error(res.data.message);
                    }
                })
                .catch((err) => {
                    console.log(err)
                });
            },

            getMrPersonMultsearch: async function(){ // 人物信息获取
                await this.$axios.post(this.bkCommon.mrPersonMultsearchUrl, this.personParams())
                .then((res) => {
                    let resultData  = res.data;
                    this.personList.push.apply(this.personList, resultData.persons);
                    // 获取第一位人物信息
                    if( this.isEmptyObject(this.personInfo) ) {
                        this.personInfo = this.personList[0];
                    }
                })
                .catch((err) => {
                    console.log(err)
                });
            },
            personParams(){ // 人名参数设置，(防止检索时参数被覆盖，导致检索出重复的数据)
                let _personParams = {
                    "searchType": 2,
                    "freetext"  : "",// "眾生相" this.keyword
                    "expression": this.expression,
                    "cdtn" : this.personCdtn,
                    "facet": {},
                    "secondCdtn": "",
                    "pager": {
                        "pageth"  : 1,
                        "pageSize": this.pageSize
                    },
                    "sorts": {
                        "SJ": "0"
                    },
                    "hasFacet": true
                }
                return _personParams;
            },
            getPerson(data){
                this.personList = [];
                this.personInfo = {};
                if(data && data.length > 0){
                    // 取数量最多的3位人物
                    if(data.length > 3) data.sort(this.objectArraySort('count')).slice(0,3);
                    data.forEach(item => {
                        this.personCdtn = [{
                            "logic": "",
                            "field": "URI",
                            "value": item.facet,
                            "type" : "1"
                        }]
                        this.getMrPersonMultsearch();
                    })
                }
            },
            namesHandle(nameType, nameType2, data){ // 名字分类处理
                if(data == null || data.length == 0) return '';
                let arr = new Array();
                data.forEach((item) => {
                    if(!item.nameType) return;
                    if(!this.isEmpty(nameType)  && item.nameType.indexOf(nameType) != -1){
                        arr.push(item.label);
                    }
                    if(!this.isEmpty(nameType2) && item.nameType.indexOf(nameType2) != -1){
                        if(nameType2 == '号' && item.nameType.indexOf('谥号') != -1) return;
                        arr.push(item.label);
                    }
                });
                return this.unique(arr, null).slice(0, 2).join(' '); // 去重并截取前3位
            },
            objectArraySort(keyName) { // 排序，由大到小
                return function (objectN, objectM) {
                    var valueN = objectN[keyName]
                    var valueM = objectM[keyName]
                    if (valueN < valueM) return 1
                    else if (valueN > valueM) return -1
                    else return 0
                }
            },
            charts(){
                localStorage.bkVisParams = this.$qs.stringify(this.params);
                this.$router.push("/bk/searchResultCharts");
                // this.$router.push({name:"bkEcharts", params:{visParams: JSON.stringify(this.params)}});
            },
            zTreeInit(str, zNodes){ // 初始化树状分面
                let _treeIdKey  = str + 'TreeId';
                let _treeObjKey = str + 'TreeObj';
                $.fn.zTree.init($("#"+_treeIdKey), this.setting, zNodes);
                this[_treeObjKey] = $.fn.zTree.getZTreeObj(_treeIdKey);
            },
            zTreeNodeType(str){
                let typeArr = {
                    正文类别  : 'CT',
                    文章栏目  : 'CLM',
                    新闻来源  : 'NPLC',
                    新闻发布地: 'NT',
                }
                return typeArr[str];
            },
            zTreeOnClick(event, treeId, treeNode){ // 分类树点击
                if(treeNode.level == 1) return;
                this.facetParams = {};
                let _type = '';
                let _level = treeNode.level;
                switch (_level) {
                    case 0:
                        this.facetParams.TP = treeNode.facet;
                        break;
                    case 1:
                        // _type               = this.zTreeNodeType(treeNode.facet);
                        // this.facetParams.TP     = treeNode.getParentNode().facet;
                        // this.facetParams[_type] = '';
                        break;
                    case 2:
                        var _parentNode         = treeNode.getParentNode();
                        _type                   = this.zTreeNodeType(_parentNode.facet);
                        this.facetParams.TP     = _parentNode.getParentNode().facet;
                        this.facetParams[_type] = treeNode.facet;
                        break;
                    default:
                        break;
                }
                this.isFacet = 1;
                this.getArticleSearch();
            },
            zTreeOnExpand(event, treeId, treeNode){ // 分类树展开
                if(treeNode.level == 0) this.arrowChange += 1;
                let len = this.nrTypeTreeObj.getNodes().length;
                if(this.arrowChange == len){
                    this.showMore1   = true;
                    this.arrowChange = 0;
                }
            },
            zTreeOnCollapse(event, treeId, treeNode){ // 分类树收缩
                this.showMore1 = false;
            },
            zTreeOnNodeCreated(event, treeId, treeNode){ // 节点创建后
                let _nodeId = '#'+treeNode.tId;
                if(treeNode.count){
                    let _span = "<span class='count'>" + treeNode.count + "</span>";
                    $(_nodeId).append(_span);
                }
                $(_nodeId).addClass("cur");
                $(_nodeId).css("position", "relative"); // before
            },
            addDiyDom(treeId, treeNode){ // 对字体进行判断，过长用...代替
                let _nodeId = '#'+treeNode.tId + '_span';
                if(treeNode.facet.length >= 12) {
                    $(_nodeId).text(treeNode.facet.slice(0, 12) + '...');
                }
            },
            onPagethChange(){   // 页码改变
                this.isFacet = 1;
                if(this.isNotExport) {
                    this.indeterminate = false;
                    this.checkboxAll   = false;
                }
                // this.getArticleSearch();
                this.onSortChange();
            },
            onPageSizeChange(){ // 每页数目改变
                this.pageth = 1;
                this.isFacet = 1;
                this.onSortChange();
            },
            firstPage(){ // 首页
                if(this.pageth == 1) return;
                this.pageth = 1;
                this.onSortChange();
            },
            prevPage(){ //上一页
                if(this.pageth == 1) return;
                this.pageth -= 1;
                this.onSortChange();
            },
            nextPage(){ // 下一页
                if(this.pageth == this.pageCount) return;
                this.pageth += 1;
                this.onSortChange();
            },
            lastPage(){ // 末页
                if(this.pageth == this.pageCount) return;
                this.pageth = this.pageCount;
                this.onSortChange();
            },
            changeKeyword(val){
                this.keyword = val
            },

            async handleFav(uri, title, type, year, week){
                this.favUri = uri
                this.favTitle = title
                this.favType = type
                this.favYear = year
                this.favWeek = week
                let index = this.collectedDataSource.indexOf(this.favUri)
                if(index>-1) { // 取消收藏
                    this.collectedDataSource.splice(index,1)
                    this.collectHandle(this.favUri, this.favTitle)
                } else {  // 添加收藏 
                    this.favorFolders = []
                    this.favorFolderId = ""
                    await this.$axios.post(this.Common.searchFavorites, {
                        appId: "history",
                        userId: this.Common.userInfo.id,
                        version: "1.0",
                        token: this.token||this.getTokenFunc(),
                        body: {}
                    }).then(response => {
                        let list = response.data.body
                        if(list && list.length>0 && list.map(element=>element.favoritesType).indexOf('D')>-1) {
                            list.forEach(element => {
                                if(element.favoritesType=='D') {
                                    this.favorFolders.push(element)
                                }
                            });
                            this.favorFolderId = this.favorFolders[0].id
                            this.favorVisible = true
                            this.ifCreateFlag = false
                            this.inputFolderName = ""
                        } else {
                            this.createFolder("默认")
                        }
                    });
                }
            },

            createFav() {
                // this.dataSource.splice(index,1,{ ...this.dataSource[index], isFav: !this.dataSource[index].isFav })
                this.collectedDataSource.push(this.favUri)
                let prefix = ""
                if(this.favType=="magazine") {
                    prefix = "https://dhc.library.sh.cn/bk/magazineimg?articleUri="
                }
                if(this.favType=="newspaper") {
                    prefix = "https://dhc.library.sh.cn/bk/newspaperimg?articleUri="
                }
                this.createCollect(this.favUri, this.favTitle, prefix, this.favYear, this.favWeek, this.favorFolderId) // 添加收藏
                this.favorVisible = false
            },

            async createFolder(name) {
                if(!name.trim()) {
                    this.$message.error("收藏夹名称不能为空");
                } else {
                    await this.$axios.post(this.Common.createFavorites, {
                        appId: "history",
                        userId: this.Common.userInfo.id,
                        version: "1.0",
                        token: this.token||this.getTokenFunc(),
                        body: {
                            name: name,
                            parent: 0,
                            favoritesType: "D"
                        }
                    }).then(response => {
                        if(response.data.resultCode=="0000") {
                            this.handleFav(this.favUri, this.favTitle)
                        } else {
                            this.$message.error("System Error");
                        }
                    });
                }
            },

            handleSelect(index){
                this.dataSource.splice(index,1,{
                    ...this.dataSource[index],
                    isSelect: !this.dataSource[index].isSelect
                })
            },
            highLight(item){
                let personName = item.name;
                return personName.split(this.keyword).join('<b>'+this.keyword+'</b>')
            },
            changeInfoTap(item, index){ // personInfo
                this.infoTap    = index;
                this.personInfo = item;
            },
            handleLeaveP(){
                this.showHoverPerson=false
            },
            handleLeaveB(){
                this.showHoverBook=false
            },
            handleHoverP(e){
                this.showHoverPerson=true
                this.showHoverBook=false
                this.hoverPersonX=e.clientX-100
                this.hoverPersonY=e.clientY+20
            },
            handleHoverB(e, item){ // 悬浮框
                this.showHoverBook=true
                this.showHoverPerson=false
                this.hoverBookX=e.clientX-100
                // this.hoverBookY=e.clientY+20
                setTimeout(() => { // 调节弹出框高度
                    // 获取弹出框高度
                    let _height = $('div.book-hover').height() + 24;
                    // 获取弹出框 位置 + 高度
                    let _hoverBookY = e.clientY + 20 + _height;
                    // 获取页码可见区域高度
                    let bodyHeight = document.body.clientHeight;
                    if(bodyHeight > _hoverBookY){
                        this.hoverBookY=e.clientY + 20;
                    }
                    else {
                        this.hoverBookY=e.clientY - _height - 20;
                    }
                }, 100);
                this.handleHoverItem = item;
            },
            fullBrowse(item){ // 整本浏览
                if(!item.hasFullImage) return this.$message.warning("暂无全文", 1);
                let _ID = '';
                let manifestsKey = '';
                let typeName = item.newspaper.typeName; // == '近代报纸'
                switch (typeName) {
                    case '近代报纸':
                        this.$router.push('/bk/newspaperimg');
                        break;
                    case '近代期刊':
                        manifestsKey = item.issue.issued[0].year + item.issue.issueNo;
                        localStorage.CV = 0;
                        localStorage.manifestsKey = manifestsKey;
                        this.$router.push('/bk/magazineimg');
                        break;
                    default:
                        break;
                }
            },
            yulan2(item){ // 单篇预览
                if(!item.hasFullImage) return this.$message.warning("暂无全文", 1);
                let _ID = '';
                let manifestsKey = '';
                if(item.typeName == '广告'){
                    localStorage.advertisementData = this.$qs.stringify(item);
                    this.$router.push('/bk/advertisementimg');
                    return;
                }
                let bkTypeName = item.newspaper.typeName; // == '近代报纸'
                switch (bkTypeName) {
                    case '近代报纸':
                        this.$router.push('/bk/newspaperimg');
                        break;
                    case '近代期刊':
                        // _ID = item['@id'];
                        // manifestsKey = item.issue.publishedIn[0].year + item.issue.issueNo;
                        if(item.issue && item.issue.issued && item.issue.issued[0].year && item.issue.issueNo){
                            localStorage.articleUri   = item['@id'];
                            localStorage.manifestsKey = item.issue.issued[0].year +''+ item.issue.issueNo;
                            if(!this.bkCommon.magazineFullManifests[localStorage.manifestsKey]) return this.$message.warning("暂无全文", 1);
                            this.$router.push('/bk/magazineimg');
                        }
                        else this.$message.warning("暂无全文", 1);
                        break;
                    default:
                        break;
                }
            },
            zjBrowse(item){ // 专辑浏览
                if(!item.hasFullImage) return this.$message.warning("暂无全文", 1);
                this.$router.push('/bk/newspaperimg');
            },
            bkSearchShow(visible){
                this.bkSearchTabShow = visible;
                this.unScroll(); // 禁止滚动条滚动
            },
            bkSearchHide(visible){
                this.bkSearchTabShow = visible;
                this.removeUnScroll(); // 移除禁止滚动条滚动
            },
            onChange(checkedList) { // 单个复选框勾选
                this.indeterminate = !!checkedList.length && checkedList.length < this.plainOptions.length;
                this.checkboxAll = checkedList.length === this.plainOptions.length;
            },
            onCheckAllChange(e) { // 全选
                Object.assign(this, {
                    checkedList: e.target.checked ? this.plainOptions : [],
                    indeterminate: false,
                    checkboxAll: e.target.checked,
                });
            },
            async onExport(){ // 结果导出
                let _this = this;
                if( !_this.Common.userInfo ){
                    _this.$Modal.info({ content : '请登录!', okText  : '确定', });
                    return;
                }
                if( this.isEmptyArray(this.checkedList) ){
                    _this.$Modal.info({ content : '请至少勾选一条内容!', okText  : '确定', });
                    return;
                }
                _this.isNotExport  = false; // 导出
                if(_this.checkboxAll){
                    await _this.$Modal.confirm({
                        title           : '结果导出',
                        content         : '每种文献最多导出100条数据，是否继续？',
                        cancelText      : '取消',
                        okText          : '确定',
                        confirmLoading  : false,
                        onCancel() { }, // 取消
                        async onOk() {  // 确定
                            // _this.$loading.show("正在导出...");
                            _this.pageSize = 100;
                            await _this.onSortChange(); // 重新获取数据
                            _this.onResultExport();
                            // _this.$loading.hide();
                        },
                    });
                } 
                else {
                    _this.spinning = true; // 加载中...
                    await _this.onSortChange(); // 重新获取数据
                    _this.onResultExport();
                    _this.spinning = false; // 加载结束
                }
            },
            onResultExport(){ // 导出内容设置
                let _this = this;
                _this.litePageSize = 10;
                let title      = [];     // csv文档标题
                let exportData = [];     // csv文档数据
                let fileName   = 'temp'; // 文件名
                let titleArr   = [
                    {ch:'标题',     en:"title"}, 
                    {ch:'创建时间', en:"created"}, 
                    {ch:'发布者',   en:"creator"}, 
                    {ch:'类别',     en:"category"}, 
                    {ch:'来源',     en:"source"}, 
                    {ch:'资源uri',  en:"uri"}
                ]; // 文档标题集合
                titleArr.forEach((item) => {
                    title.push({title: item.ch  , field: item.en});  // 设置标题
                })
                exportData = this.onCsvExportData();
                _this.JSONToExcelConvertor(title, exportData, fileName); // 导出csv文件
            },
            onCsvExportData(){ // csv导出数据处理
                let exportData = [];
                let _List = this.checkboxAll ? this.exportList : this.checkedList;
                for(let i=0, len=_List.length; i<len; i++){
                    let item = _List[i];
                    exportData.push({
                        title       : item.title,
                        created     : item.sj ? item.sj.year : '',
                        creator     : item.creator,
                        category    : item.category,
                        source      : item.source,
                        uri         : item['@id'],
                    })
                }
                return exportData;
            }
        },
        computed: {
            params(){
                return {
                    "searchType": this.searchType,
                    "freetext"  : this.keyword,// "眾生相" this.keyword
                    "expression": this.expression,
                    "cdtn" : this.cdtnParams,
                    "facet": this.facetParams,
                    "secondCdtn": "",
                    "pager": {
                        "pageth"  : this.pageth,
                        "pageSize": this.pageSize
                    },
                    "sorts": {},
                    "hasFacet": true
                }
            },
            activeUserInfo(){
                return this.Common.userInfo;
            },
        },
        watch: {
        }
    }
</script>

<style scoped lang="less">
    /deep/ .ant-modal-content, /deep/ .ant-modal-header {
        background: #E8F1F9;
    }
    /deep/ .ant-modal {
        top: 35%;
        padding-bottom: 0;
    }
    /deep/ .anticon-plus {
        position: relative;
        display: inline-block;
        cursor: pointer;
    }
    /deep/ .anticon-close-circle, /deep/ .anticon-check-circle {
        margin-left: 6%;
    }
    /deep/ .ant-input {
        width: 70%;
    }

    /deep/ .ztree{
        margin-bottom: 20px;
        padding: 5px 0 5px 5px;
        &.cur{
            max-height: none!important;
            overflow-y: inherit!important;
        }
        li{
            position: relative;
            // padding-left: 5px;
            .count{
                width: 50px;
                position: absolute;
                top: 2px;
                right: -2px;
                height: 18px;
                background: #394d8f;
                line-height: 18px;
                text-align: center;
                border-radius: 5px;
                color: #fff;
            }
            &:before{
                position: absolute;
                width: 6px;
                height: 6px;
                background: #00afeb;
                content: "";
                left: -26px;
                top: 8px;
                border-radius: 50%;
            }
            a{
                color: #fff;
                line-height: 22px;
                display: inline-block;
                width: 100%;
                height: 22px;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                &:hover{
                    text-decoration: underline;
                }
            }
            span{
                display: inline-block;
                max-width: 80px;
                &.button{
                    &.switch{
                        width: 18px;
                    }
                    &.noline_close{
                        background-position: -133px -84px;
                    }
                    &.noline_open{
                        background-position: -112px -84px;
                    }
                }
            }
        }
        // 消除子节点的小圆点
        .level1,
        .level2,
        .level3,
        .level4,
        .level5 {
            &:before{
                display: none;
            }
        }
        ul.level1{
            max-height: 300px;
            overflow-y: auto;
            overflow-x: hidden;
            // 滚动条样式
            &::-webkit-scrollbar {
                width: 6px;
                height: 6px;
            }
            &::-webkit-scrollbar-thumb {
                border-radius: 10px;
                -webkit-box-shadow: inset 0 0 5px rgba(255, 255, 255, 0.4);
                box-shadow: inset 0 0 5px rgba(255, 255, 255, 0.4);
                background: rgba(255, 255, 255, 0.4);
            }
            &::-webkit-scrollbar-track {
                -webkit-box-shadow: inset 0 0 5px rgba(255, 255, 255, 0.4);
                box-shadow: inset 0 0 5px rgba(255, 255, 255, 0.4);
                border-radius: 5px;
                background: rgba(255, 255, 255, 0.2);
            }
        }
    }

    .book-hover{
        position: fixed;
        width: 450px;
        background: #deebf3;
        padding: 12px;
        border-radius: 10px;
        top: 400px;
        left: 0;
        z-index: 999;
        .btns{
            justify-content: space-between;
            margin-top: 10px;
            display: flex;
            padding: 0 20px;
            a{
                display: flex;
                align-items: center;
                color: #042354;
                line-height: 34px;
                border-bottom: none;
                img{
                    width: 25px;
                    height: 25px;
                    margin-right: 6px;
                }
            }
        }
        .desc{
            // display: flex;
            justify-content: space-between;
            color: #042354;
            p{
                margin: 0;
                margin-bottom: 5px;
            }
            .lf{
                flex-grow: 1;
                flex-shrink: 0;
                margin-right: 10px;
                width: 96%;
            }
            .rt{
                flex-grow: 1;
                flex-shrink: 0;
            }
        }
    }
    .person-hover{
        position: fixed;
        width: 450px;
        background: #deebf3;
        padding: 12px;
        border-radius: 10px;
        display: flex;
        align-items: flex-start;
        top: 0;
        left: 0;
        z-index: 999;
        img{
            width: 105px;
            margin-right: 15px;
            flex-shrink: 0;
        }
        .info{
            flex-grow: 1;
            color: #042354;
            .name{
                font-size: 14px;
                border-bottom: 1px solid #042354;
                display: inline-block;
            }
            .des{
                font-size: 12px;
                line-height: 1.8;
                margin-top: 10px;
            }
        }
        .ot{
            display: flex;
            font-size: 16px;
            margin-top: 20px;
            a{
                color: #042354;
                margin: 0 10px;
                height: 30px;
                display: flex;
                justify-content: center;
                align-items: center;
                width: 110px;
                img{
                    margin-right: 5px;
                    max-width: 20px;
                }
            }
        }

    }
    .result-main-box{
        background: #19234b;
        width: 100%;
        min-height: calc(100vh);
    }
    .result-main{
        width: 100%;
        padding: 0 20px;
        &.cur{
            opacity: 0.1;
        }
        .top-ctrl{
            width: 100%;
            display: flex;
            justify-content: flex-end;
            align-items: center;
            span{
                color: #f0be73;
                margin-left: 20px;
                line-height: 30px;
                display: flex;
                justify-content: center;
                align-items: center;
                cursor: pointer;
                img{
                    max-height: 20px;
                    margin-right: 5px;
                }
            }
        }
    }
    .result-container{
        display: flex;
        justify-content: space-between;
        margin-top: 10px;
        color: #fff;
        align-items: flex-start;
        .left-box{
            width: 27%;
            margin-left: 40px;
            .waterfall-list{
                margin-top: 20px;
                display: flex;
                flex-direction: row;
                flex-wrap: wrap;
                transform: scale(0);
                transition: opacity .2s .1s,transform .5s .1s;
                &.cur{
                    opacity: 1;
                    transform: scale(1);
                }
                ul{
                    width: 31%;
                    margin-right: 2%;
                    font-size: 12px;
                    li{
                        position: relative;
                        width: 100%;
                        list-style: none;
                        border-radius: 10px;
                        overflow: hidden;
                        margin-bottom: 10px;
                        &:nth-child(3n){
                            margin-right: 0;
                        }
                        img{
                            width: 100%;
                            height: auto;
                        }
                        &:hover{
                            .hover-box{
                                opacity: 1 ;
                            }
                        }
                        .hover-box{
                            position: absolute;
                            width: 100%;
                            height: 100%;
                            top: 0;
                            left: 0;
                            opacity: 0;
                            transition: opacity .4s;
                            display: flex;
                            flex-direction: column;
                            padding: 5px;
                            justify-content: space-between;
                            align-items: center;
                            .btn{
                                width: 95%;
                                display: flex;
                                justify-content: flex-end;
                                align-items: center;
                                a{
                                    width: 26px;
                                    height: 26px;
                                    border-radius: 13px;
                                    background: #c0bfbf;
                                    text-align: center;
                                    line-height: 26px;
                                    margin-left: 10px;
                                    color: #2e3e7a;
                                    font-weight: bold;
                                }
                            }
                            .save{
                                width: 95%;
                                background: rgba(255,255,255,.7);
                                height: 30px;
                                color: #2e3e7a;
                                line-height: 30px;
                                padding-left: 9px;
                                border-radius: 5px;
                                display: flex;
                                justify-content: space-between;
                                overflow: hidden;
                                button{
                                    background: #2e3e7a;
                                    height: 30px;
                                    line-height: 30px;
                                    color: #fff;
                                    padding: 0 9px;
                                }
                            }
                        }
                    }
                }
            }
            .info-box{
                width: 100%;
                background: #2e3f7a;
                padding: 15px 15px 60px 15px;
                position: relative;
                border-top-right-radius: 5px;
                border-bottom-right-radius: 5px;
                opacity: 0;
                transform: scale(0);
                transition: opacity .2s,transform .5s;
                &.cur{
                    opacity: 1;
                    transform: scale(1);
                }
                .bottom{
                    position: absolute;
                    width: 100%;
                    height: 60px;
                    bottom: 0;
                    left: 0;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    .more{
                        position: absolute;
                        width: 40px;
                        left: -40px;
                        height: 60px;
                        border-bottom-left-radius: 5px;
                        background: #222f60;
                        border-top-left-radius: 5px;
                        text-align: center;
                        line-height: 60px;
                    }
                    .ot{
                        display: flex;
                    }
                    a{
                        color: #f0be73;
                        margin: 0 10px;
                        height: 30px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        img{
                            margin-right: 5px;
                            max-height: 20px;
                        }
                    }
                }
                .taps{
                    position: absolute;
                    width: 40px;
                    top: 0;
                    left: -40px;
                    span{
                        display: block;
                        width: 40px;
                        padding: 10px;
                        box-sizing: border-box;
                        border-bottom-left-radius: 5px;
                        background: #222f60;
                        border-top-left-radius: 5px;
                        cursor: pointer;
                        &.cur{
                            background: #2e3f7a;
                        }
                        /deep/ b{
                            font-weight: normal;
                            color: #f0be73;
                        }
                    }
                }
                .detail{
                    i.icon{
                        position: absolute;
                        width: 24px;
                        height: 43px;
                        background-size: 100% 100%;
                        background-image: url("./../magazineDetail/tag.png");
                        top: -10px;
                        left: 0;
                    }
                    // 人名，固定最小高度
                    min-height: 300px;
                    img{
                        display: block;
                        margin: 0 auto;
                        width: 50%;
                        height: auto;
                    }
                    .txt{
                        font-size: 13px;
                        margin: 15px 0;
                        p{
                            line-height: 1.4;
                            margin: 0;
                        }
                        table{
                            width: 100%;
                            border: 1px solid #fff;
                            margin-top: 10px;
                            tr{
                                border-bottom: 1px solid #fff;
                            }
                            td{
                                padding: 4px 7px;
                                border-right: 1px solid #fff;
                            }
                        }
                    }
                }
            }
        }
        .middle-result{
            width: 26%;
            transform: scale(0);
            transition: opacity .2s .2s,transform .5s .2s;
            padding-top: 50px;
            border-top-left-radius: 20px;
            background: #222f60;
            &.cur{
                opacity: 1;
                transform: scale(1);
            }
            .re-tit{
                background: #222f60;
                border-top-right-radius: 5px;
                border-top-left-radius: 5px;
                line-height: 26px;
                text-align: right;
                padding: 5px 15px;
            }
            .result-from{
                .from-cell{
                    display: flex;
                    background: #2e3f7a;
                    color: #fff;
                    padding-left: 40px;
                    font-size: 12px;
                    &:nth-child(2n){
                        background: #222f60;
                    }
                    .ct-nox{
                        padding: 10px 10px 10px 0;
                        margin-left: 15px;
                        flex-grow: 1;
                        .ts{
                            line-height: 1.4;
                            font-size: 14px;
                            margin-bottom: 6px;
                            color: #f0be73;
                        }
                        ul{
                            transition: height .5s;
                            // &.ztree{
                            //     max-height: 300px;
                            //     overflow-y: auto;
                            //     overflow-x: hidden;
                            // }
                            &.cur{
                                max-height: 300px;
                                overflow-y: auto;
                                // overflow-x: hidden;
                                li{
                                    position: relative;
                                    pointer-events: none;
                                    opacity: 0;
                                    transition: opacity .3s,transform .3s;
                                    transform: scale(1,0);
                                    &.cur{
                                        pointer-events: auto;
                                        opacity: 1;
                                        transform: scale(1,1);
                                    }
                                    span{
                                        width: 50px;
                                        position: absolute;
                                        top: 2px;
                                        right: 0;
                                        height: 18px;
                                        background: #394d8f;
                                        line-height: 18px;
                                        text-align: center;
                                        border-radius: 5px;
                                    }
                                }
                            }
                            // &.cur2{
                            //     overflow: hidden;
                            // }
                            // 滚动条样式
                            // &.ztree::-webkit-scrollbar,
                            &.cur::-webkit-scrollbar {
                                width: 6px;
                                height: 6px;
                            }
                            // &.ztree::-webkit-scrollbar-thumb,
                            &.cur::-webkit-scrollbar-thumb {
                                border-radius: 10px;
                                -webkit-box-shadow: inset 0 0 5px rgba(255, 255, 255, 0.4);
                                box-shadow: inset 0 0 5px rgba(255, 255, 255, 0.4);
                                background: rgba(255, 255, 255, 0.4);
                            }
                            // &.ztree::-webkit-scrollbar-track,
                            &.cur::-webkit-scrollbar-track {
                                -webkit-box-shadow: inset 0 0 5px rgba(255, 255, 255, 0.4);
                                box-shadow: inset 0 0 5px rgba(255, 255, 255, 0.4);
                                border-radius: 5px;
                                background: rgba(255, 255, 255, 0.2);
                            }
                            li{
                                position: relative;
                                pointer-events: none;
                                opacity: 0;
                                transition: opacity .3s,transform .3s;
                                transform: scale(1,0);
                                &.cur{
                                    pointer-events: auto;
                                    opacity: 1;
                                    transform: scale(1,1);
                                }
                                span{
                                    width: 50px;
                                    position: absolute;
                                    top: 2px;
                                    right: 0;
                                    height: 18px;
                                    background: #394d8f;
                                    line-height: 18px;
                                    text-align: center;
                                    border-radius: 5px;
                                }
                            }
                        }
                        .more{
                            color: #999;
                            padding-left: 5px;
                            display: flex;
                            justify-content: space-between;
                            span{
                                cursor: pointer;
                            }
                            a{
                                color: #fff;
                                img{
                                    max-height: 18px;
                                }
                            }
                        }
                        li{
                            position: relative;
                            padding-left: 5px;
                            &:before{
                                position: absolute;
                                width: 6px;
                                height: 6px;
                                background: #00afeb;
                                content: "";
                                left: -22px;
                                top: 8px;
                                border-radius: 50%;
                            }
                            a{
                                color: #fff;
                                line-height: 22px;
                                display: block;
                                width: 100%;
                                height: 22px;
                                overflow: hidden;
                                white-space: nowrap;
                                text-overflow: ellipsis;
                                &:hover{
                                    text-decoration: underline;
                                }
                            }
                        }
                    }
                    b{
                        width: 55px;
                        font-size: 24px;
                        line-height: 1.4;
                        font-family: FZZJ-LJDXKJW;
                        font-weight: normal;
                        padding: 15px 15px;
                        color: #00afeb;
                        opacity: .8;
                    }
                    .arr{
                        width: 7px;
                        position: relative;
                        .arrow{
                            position: absolute;
                            bottom: 15px;
                            left: 50%;
                            transform: translate(-50%,0);
                            color: rgba(0,175,235,1);
                        }
                        &:before{
                            position: absolute;
                            content: "";
                            background: linear-gradient(to bottom,rgba(0,175,235,0),rgba(0,175,235,1));
                            width: 1px;
                            height: 20%;
                            top: 0;
                            left: 3px;
                        }
                        span{
                            position: absolute;
                            background: rgba(0,175,235,1);
                            width: 1px;
                            bottom: 20%;
                            top: 20%;
                            left: 3px;
                        }
                        &:after{
                            position: absolute;
                            content: "";
                            background: linear-gradient(to bottom,rgba(0,175,235,1),rgba(0,175,235,0));
                            width: 1px;
                            height: 20%;
                            bottom: 0;
                            left: 3px;
                        }
                    }
                }
            }
        }
        .star{
            display: inline-block;
            width: 25px;
            height: 25px;
            background-size: 100% 100%;
            background-image: url("./img/star.png");
            cursor: pointer;
            &.cur{
                background-image: url("./img/star2.png");
            }
        }
        .right-act{
            width: 43%;
            background: #222f60;
            border-top-left-radius: 10px;
            border-top-right-radius: 10px;
            transform: scale(0);
            transition: opacity .2s .3s,transform .5s .3s;
            &.cur{
                opacity: 1;
                transform: scale(1);
            }
            .r-list{
               .r-cell{
                   background: #2b3b73;
                   display: flex;
                   padding: 20px 10px;
                   justify-content: space-between;
                   align-items: center;
                   line-height: 1.6;
                   &:nth-child(2n){
                       background: none;
                   }
                   a{
                       color: #fff;
                       display: inline-block;
                       border-bottom: 1px solid #f0be73;
                   }
                   .info{
                       flex-grow: 1;
                       margin-left: 10px;
                       .des{
                           span,a{
                               padding: 0 5px;
                           }
                       }
                   }
                   .btns{
                        // width: 200px;
                        // width: 90px;
                        display: flex;
                        flex-shrink: 0;
                        // flex-wrap: wrap;
                        justify-content: space-between;
                        align-items: center;
                        a{
                        //    display: flex;
                            display: inline-block;
                            align-items: center;
                            width: 48%;
                            color: #fff;
                            // line-height: 34px;
                            line-height: 10px;
                            border-bottom: none;
                            img{
                                width: 25px;
                                height: 25px;
                                margin-right: 6px;
                            }
                        }
                   }
                   .check{
                       width: 16px;
                       height: 16px;
                       box-sizing: border-box;
                       border: 1px solid #fff;
                       border-radius: 2px;
                       position: relative;
                       margin-left: 10px;
                       cursor: pointer;
                       &.cur{
                           &:after{
                               position: absolute;
                               content: "";
                               width: 11px;
                               height: 8px;
                               top: 4px;
                               left: 2px;
                               background-size: 100% 100%;
                               background-image: url("./img/check.png");
                           }
                       }
                   }
                   .checkbox{
                       margin-left: 10px;
                   }
               }
            }
            .search-info{
                display: flex;
                padding: 10px;
                align-items: center;
                font-size: 12px;
                justify-content: space-between;
                select{
                    background: #36498a;
                    color: #fff;
                    height: 24px;
                    // width: 120px;
                    width: auto;
                    padding: 0 10px;
                    border: none;
                    box-sizing: border-box;
                    resize: none;
                    border-radius: 10px;
                    outline: none;
                    margin-left: 5px;
                    &.lg{
                        width: 95px;
                    }
                }
                .info{
                    flex-grow: 1;
                    text-align: center;
                }
                .sort{
                    align-items: center;
                    display: flex;
                    width: 200px;
                    flex-shrink: 0;
                }
                .pages{
                    width: 230px;
                    height: 24px;
                    display: flex;
                    align-items: center;
                    a{
                        background-size: 100% 100%;
                        margin: 0 4px;
                        flex-shrink: 0;
                        &.first{
                            width: 10px;
                            height: 15px;
                            background-image: url("./img/first.png");
                        }
                        &.prev{
                            width: 10px;
                            height: 15px;
                            background-image: url("./img/prev.png");
                        }
                        &.next{
                            width: 10px;
                            height: 15px;
                            background-image: url("./img/next.png");
                        }
                        &.last{
                            width: 10px;
                            height: 15px;
                            background-image: url("./img/last.png");
                        }
                    }
                }
            }
            .result-info{
                margin: 10px;
                .info{
                    font-size: 12px;
                    margin: 10px;
                    display: inline-block;
                    .vertical{
                        color: #f0be73;
                        font-size: 14px;
                    }
                }
            }

            // 多选框样式
            /deep/ .ant-checkbox-group,
            .ant-checkbox-wrapper{
                color: #fff!important;
                display: initial!important;
            }
            /deep/ .ant-checkbox-wrapper:hover .ant-checkbox-inner, 
            .ant-checkbox:hover .ant-checkbox-inner, 
            .ant-checkbox-input:focus + .ant-checkbox-inner{
                border-color: transparent!important;
                border: 1px solid #fff!important;
                background-color: transparent!important;
            }
            /deep/ .ant-checkbox-checked{
                &::after{
                    border: transparent!important;
                }
                .ant-checkbox-inner{
                    background-size: 81%!important;
                    background-repeat: no-repeat!important;
                    background-image: url('../../../assets/images/check2.png')!important;
                    background-color: transparent!important;
                    border-color: transparent!important;
                    border: 1px solid #fff!important;
                    &::after{
                        border: transparent!important;
                    }
                }
            }
            /deep/ .ant-checkbox-inner{
                background-color: transparent!important;
                border-color: transparent!important;
                border: 1px solid #fff!important;
            }
            /deep/ .ant-checkbox-indeterminate{
                .ant-checkbox-inner{
                    &::after{
                        background-color: #fff!important;
                    }
                }
            }
        }
    }
</style>
